import { lazy } from 'react';
import { pathFactory } from '@hwm/ui-lib/core/routes';

const DataView = lazy(() => import('@features/DataView'));
const Alarms = lazy(() => import('@features/Alarms'));
const History = lazy(() => import('@features/History'));
const Reporting = lazy(() => import('@features/Reporting'));
const SiteInformation = lazy(() => import('@features/SiteInformation'));

export const AppPaths = {
  dataView: pathFactory(
    {
      base: '/dashboard',
    },
    DataView,
    true
  ),
  alarms: pathFactory(
    {
      base: '/alarms',
    },
    Alarms,
    true
  ),
  history: pathFactory(
    {
      base: '/history',
    },
    History,
    true
  ),
  reporting: pathFactory(
    {
      base: '/reporting',
    },
    Reporting,
    true
  ),
  siteInformation: pathFactory(
    {
      base: '/siteInformation',
    },
    SiteInformation,
    true
  ),
};
